import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

interface GoogleMapProps {
  latitude: number;
  longitude: number;
  address?: string;
  height?: string | number;
}

const GoogleMap: React.FC<GoogleMapProps> = ({ 
  latitude, 
  longitude, 
  address,
  height = 400 
}) => {
  const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  
  // URL do Google Maps Embed API
  const mapUrl = `https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAPS_API_KEY}&q=${latitude},${longitude}&zoom=15`;
  
  // URL para abrir no Google Maps (app ou web)
  const openInMapsUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;

  return (
    <Paper elevation={2} sx={{ overflow: 'hidden' }}>
      {address && (
        <Box sx={{ p: 2, bgcolor: 'primary.main', color: 'white' }}>
          <Typography variant="subtitle2">
            📍 {address}
          </Typography>
          <Typography variant="caption" sx={{ opacity: 0.9 }}>
            Lat: {latitude.toFixed(6)}, Lng: {longitude.toFixed(6)}
          </Typography>
        </Box>
      )}
      
      <Box sx={{ position: 'relative', height }}>
        <iframe
          width="100%"
          height="100%"
          style={{ border: 0 }}
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          src={mapUrl}
          title="Mapa de localização"
        />
        
        {/* Botão para abrir no Google Maps */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 16,
            right: 16,
            zIndex: 1
          }}
        >
          <a
            href={openInMapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
          >
            <Paper
              elevation={3}
              sx={{
                px: 2,
                py: 1,
                bgcolor: 'white',
                cursor: 'pointer',
                '&:hover': {
                  bgcolor: 'grey.100'
                }
              }}
            >
              <Typography variant="caption" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                🗺️ Abrir no Google Maps
              </Typography>
            </Paper>
          </a>
        </Box>
      </Box>
    </Paper>
  );
};

export default GoogleMap;
